import { Action } from "../../../actions/actions";
import { ConfigurationsActionTypes } from "../actions/actionTypes";

export function productionServer(
    state: boolean = false,
    action: Action
): boolean {
    switch (action.type) {
        case ConfigurationsActionTypes.GET_PRODUCTION_INFO_SUCCESS:
            return action.payload['production_sys'];
        case ConfigurationsActionTypes.GET_PRODUCTION_INFO_FAIL:
            return false;
        default:
            return state;
    }
}
export function productionServerLoading(
    state: boolean = true,
    action: Action
): boolean {
    switch (action.type) {
        case ConfigurationsActionTypes.GET_PRODUCTION_INFO:
            return true;
        case ConfigurationsActionTypes.GET_PRODUCTION_INFO_SUCCESS:
        case ConfigurationsActionTypes.GET_PRODUCTION_INFO_FAIL:
            return false;
        default:
            return state;
    }
}
